<template>
  <v-app id="inspire">
    <div class="productivity-report-wrap">
      <div class="inv-top-header mb-4">
        <p class="text-uppercase caption mb-0">Payroll/Payroll Report</p>
        <h2 class="headline">Productivity Report</h2>
      </div>

      <v-flex class="header-search-single">
        <v-layout xs12 class="mt-2">
          <v-flex class="mr-2" d-flex style="max-width: 300px;">
            <v-menu
              ref="menu1"
              :label="`Pay Period`"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  :value="titleDateFormat()"
                  :label="`Pay Period${payPeriodName && titleDateFormat() ? ' (' + payPeriodName + ')' : ''}`"
                  persistent-hint
                  prepend-icon="event"
                  placeholder="Please Select"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                :value="weekStartEnd"
                :title-date-format="weekDateFormat"
                first-day-of-week="1"
                multiple
                @input="updateWeek"
              >
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex>
            <v-btn
              large
              color="primary"
              dark
              class="mt-1 mr-0"
              style="min-width: 50px;"
              @click="getProductivityReports"
            >
              Apply
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :loading="loading || loadingProductivityReports"
          loader-height="2"
          hide-default-footer
          class="elevation-1 table-org mb-6 my-sticky-first-column-table my-sticky-last-column-table my-sticky-header-table"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td>
                <router-link
                  v-bind:to="'/staff/' + item.employee_id + '/show'"
                  >{{ item.last_name }}</router-link
                >
              </td>
              <td>
                <router-link
                  v-bind:to="'/staff/' + item.employee_id + '/show'"
                  >{{ item.first_name }}</router-link
                >
              </td>
              <td>
                <v-flex>
                  <template v-if="!no_data.includes(item.hour_revenue)">{{
                    `$${item.hour_revenue}`
                  }}</template>
                  <em v-else class="grey--text">No data</em>
                </v-flex>
              </td>
              <td>
                <v-flex>
                  <template v-if="!no_data.includes(item.mileage_revenue)"
                    >{{ `$${item.mileage_revenue}` }}
                  </template>
                  <em v-else class="grey--text">No data</em>
                </v-flex>
              </td>
              <td>
                <template v-if="!no_data.includes(item.count_jobs)">{{
                  item.count_jobs
                }}</template>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <template
                  v-if="!no_data.includes(item.count_complaints)"
                  >{{ item.count_complaints }}</template
                >
                <em v-else class="grey--text">No data</em>
              </td>
              <td class="actions-position1">
                <v-layout class="mx-n1">
                  <v-btn
                    @click="$router.push('productivity_report/' + item.employee_id + '/show')"
                    class="text-none pa-1 d-flex"
                    text
                    color="primary"
                    small
                  >
                    View <v-icon class="pl-1" size="16px">visibility</v-icon>
                  </v-btn>
                </v-layout>
              </td>
            </tr>
          </template>
          <template
            slot="no-data"
            v-if="error_code == 404 || error_code == 500"
          >
            <v-btn color="primary" @click="getProductivityReports()">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import EventBus from "@/main";
import ApiService from "@/common/api.service";
import moment from "moment";
import { mapGetters, mapActions } from 'vuex'

export default {
  name: "ProductivityReport",
  data: () => ({
    weekStartEnd: [],
    menu1: false,
    no_data: [null, "", undefined, "null"],
    headers: [
      { text: "Last Name", sortable: true, value: "last_name", align: "left", width: 150},
      {
        text: "First Name",
        sortable: true,
        value: "first_name",
        align: "left",
        width: 120
      },
      {
        text: "Revenue/hr ($)",
        sortable: true,
        value: "hour_revenue",
        align: "left",
        width: 140
      },
      {
        text: "Revenue/mile ($)",
        sortable: true,
        value: "years_in_service",
        align: "left",
        width: 150
      },
      {
        text: "Jobs",
        sortable: true,
        value: "count_jobs",
        align: "left",
        width: 140
      },
      {
        text: "Complaints",
        sortable: true,
        value: "count_complaints",
        align: "left",
        width: 140
      },
      {
        text: "Actions",
        sortable: false,
        align: "left",
        width: 60,
        class: "actions-position1"
      }
    ],
    items: [],
    totalItems: 0,
    search: "",
    options: {
      sortDesc: [false],
      itemsPerPage: -1,
      sortBy: ["last_name"]
    },
    loading: false,
    loadingOrganizationSettings: false,
    loadingProductivityReports: false,
    error_code: ""
  }),
  mounted() {
    this.initialize()
  },
  methods: {
    ...mapActions(['checkOrganizationSettings']),
    initialize() {
      this.loading = true
      this.getOrganizationSettings()
        .then(() => {
          return this.getProductivityReports()
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        })
    },
    getProductivityReports() {
      this.loadingProductivityReports = true;
      let body = {
        date_from: this.weekStartEnd[0],
        date_to: this.weekStartEnd[this.weekStartEnd.length - 1]
      };

      ApiService.get("/payroll/productivity_report", body)
        .then(response => {
          // this.draw++;
          this.items = response.data.productivity_report;
          this.loadingProductivityReports = false;
        })
        .catch(error => {
          this.loadingProductivityReports = false;
        });
    },
    getOrganizationSettings() {
      this.loadingOrganizationSettings = true;
      return new Promise((resolve, reject) => {
      this.checkOrganizationSettings()
        .then(response => {
          this.setWeekStartEnd()
          this.loadingOrganizationSettings = false;
          resolve()
        })
        .catch(error => {
          console.log(error);
          this.loadingOrganizationSettings = false;
          reject()
        });
      })
    },
    changeSort(column) {
      if (this.options.sortBy[0] === column) {
        this.options.sortDesc[0] = !this.options.sortDesc[0];
      } else {
        this.options.sortBy[0] = column;
        this.options.sortDesc[0] = false;
      }
    },
    updateWeek(newDate) {
      const oldDate = this.weekStartEnd;
      if (newDate.length < oldDate.length) {
        this.weekStartEnd = oldDate;
        return;
      }

      const selectedDate = newDate[newDate.length - 1];
      this.setWeekStartEnd(selectedDate);
      this.menu1 = false;
    },
    setWeekStartEnd(selectedDate) {
      this.weekStartEnd = this.payPeriodDays(selectedDate);
    },
    titleDateFormat() {
      if (this.weekStartEnd.length) {
        return `${this.weekStartEnd[0]} - ${
          this.weekStartEnd[this.weekStartEnd.length - 1]
        }`;
      } else {
        return "";
      }
    },
    weekDateFormat () {
      if(this.weekStartEnd.length) {
        if(this.payPeriod === 'weekly') {
          return `Week ${moment(this.weekStartEnd[0]).week()}`
        }
        return `${moment(this.weekStartEnd[0]).format('MM[-]DD')} to ${moment(this.weekStartEnd[this.weekStartEnd.length - 1]).format('MM[-]DD')}`
      } else {
        return ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'organizationSettings',
      'payPeriodDays',
      'payPeriod',
      'payPeriodName'
    ])
  }
};
</script>
<style>
/**tools table**/
.productivity-report-wrap div.datatable.table {
  margin-bottom: 0%;
}

.productivity-report-wrap .header-search-single {
  padding-bottom: 20px;
}

/*Search field width*/
.search-org {
  min-width: 120px;
}

td a {
  text-decoration: none;
}

.dialog-heading {
  background-color: #efefef;
  padding: 10px;
}

.no-opacity {
  opacity: 0;
}

.clear-filters {
  text-transform: none;
  color: #00838F;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
}

.productivity-report-wrap .table-head-text {
  white-space: normal;
  text-align: left;
  min-width: 100px;
}

.table-org td.actions-position {
  position: absolute;
  right: 0;
  border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-top: none !important;
  border-bottom: none !important;
  padding-top: 13px !important;
  padding-bottom: 13px !important;
  background: #fff;

  -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  will-change: background;
}

.table-org th.actions-position::before {
  content: "Actions";
  position: absolute;
  top: 0;
  right: 0;
  padding: 19px 24px;
  border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-top: none !important;
  border-bottom: none !important;
  text-align: left;
  width: 109px;
  height: 56px;
  background: #fff;
}

.table-org th.actions-position {
  width: 108px !important;
}

.table-org tr:not(:nth-child(1)) td.actions-position {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.table-org tr:hover td.actions-position {
  background: #e0f5f8;
}
</style>
